import React from 'react';
import clsx from 'clsx';
import { SearchSongCardSkeleton } from '@components/SongCards/SearchSongCardSkeleton';
import { GRID_STYLE } from '@utils/constants';
import { INITIAL_PAGE_SIZE } from './useSearchResults';

export const SearchResultsSkeleton = ({ limit = INITIAL_PAGE_SIZE }: { limit?: number }) => (
  <div className={clsx('mt-2 gap-4 md:mt-0', GRID_STYLE)}>
    {[...Array(limit)].map((_, i) => (
      <SearchSongCardSkeleton key={i} />
    ))}
  </div>
);
